import React from 'react'
import { Modal } from 'react-bootstrap'

interface ModalListProps extends ModalListChildProps {
	show: string
	data: any
	size: 'sm' | 'md' | 'lg' | 'xl'
	modals: {
		id: string
		body: (props: any) => JSX.Element
	}[]
	children?: any
	style?: {
		backdrop: boolean | 'static' | undefined
		keyboard: boolean
	}
}

type Size = 'sm' | 'lg' | 'xl'

export interface ModalListChildProps {
	handleClose: (...args: any[]) => void
}

const ModalList = (props: ModalListProps) => {
	const ShownModal = props.modals.find((m) => m.id === props.show)

	if (ShownModal) {
		return (
			<Modal
				show={true}
				size={props.size as Size}
				aria-labelledby="modal"
				centered
				backdrop={props.style && props.style.backdrop ? props.style.backdrop : undefined}
				onEscapeKeyDown={
					props.style && props.style.keyboard
						? (e) => {
								e.preventDefault()
						  }
						: undefined
				}
				onHide={props.handleClose}
			>
				<Modal.Body>
					{/* eslint-disable-next-line */}
					<ShownModal.body {...props.data} handleClose={props.handleClose} />
				</Modal.Body>
			</Modal>
		)
	} else {
		return null
	}
}

export default ModalList
